export default __webpack_public_path__ + "static/image-c14a899b01ff8bf2dc75deaea5c72e9e.png";